// extracted by mini-css-extract-plugin
module.exports = {"subfooter":"Footer-module--subfooter--Pbjtw","copyright":"Footer-module--copyright--RrwON","boksen":"Footer-module--boksen--1uCf9"};